module.exports = __webpack_public_path__ + "static/media/advantage-6.c5af8cb2.png";